'use client';

import { isIOS, isIOS13, isIPad13, isIPhone13, isMacOs } from 'react-device-detect';
import { isReactNativeWebView } from '@/lib/webview-utils';
import { AddToAppleWalletProps } from './AddToAppleWallet.types';

// Apple Wallet passes are handled by the OS, not the browser: opening the
// `.pkpass` triggers the system "Add to Apple Wallet" sheet on any browser on
// iOS/iPadOS/macOS. On Windows/Linux/Android there is no Apple Wallet, so the
// badge is hidden there (Android gets the Google Wallet button instead).
export const isApplePlatform = () =>
  isIOS || isIOS13 || isIPhone13 || isIPad13 || isMacOs || isReactNativeWebView();

export const AddToAppleWallet = ({ url }: AddToAppleWalletProps) => {
  if (!isApplePlatform()) return null;

  return (
    <a href={url} data-cy="add-to-apple-wallet-link">
      <img
        src="/images/add-to-apple-wallet.svg"
        alt="Add to Apple Wallet"
        data-cy="add-to-apple-wallet-badge"
        className="tw:h-[2.875rem] tw:cursor-pointer"
      />
    </a>
  );
};
